module.exports = __webpack_public_path__ + "static/img/bg_3_3.a9ef41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_3_3.png
// module id = HNhs
// module chunks = 3